import { P } from 'components'
import { useDebounce } from 'helpers'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Input, Spinner } from 'reactstrap'
import { useLazyFindAddressBookQuery } from '../addressBookApiSlice'
import { useLazyFetchProjectShareContactsQuery } from '../../projects-menu/projectsMenuListApiSlice'
import { setIsModalOpenAddAddressBook } from '../addressBookSlice'
import './styles.scss'

const InputAddressBook = ({
  title = 'Penjual',
  placeholderDesc = 'Cari nama atau nomor handphone dari daftar kontak Anda',
  isRequired = false,
  isPhoneUnRegistered = false,
  isPhoneRegistered = false,
  isEmailUnRegistered = false,
  isEmailRegistered = false,
  isPhoneVerified = false,
  isEmailVerified = false,
  isHarvester = false,
  isLandOwner = false,
  isRecentTrx = false,
  isNetwork = false,
  onSelectContact,
  isUppercaseValue,
  fieldName,
  invalid,
  onClickAdd,
  editValue,
  isVessel,
  onFetchingChange,
  innerRef,
  className,
  isCloseSelection = false,
  valueName,
  isCanClose = false,
  noAdd = false,
  useCombinedContacts = false,
  disabled = false,
  clearOnSelect = false,
  excludeUserIds = [],
}) => {
  const dispatch = useDispatch()
  const { isOpenSelectionAddressBook, searchAddressBook } = useSelector(
    (s) => s.addressBook,
  )
  const { profile } = useSelector((s) => s.dashboard)

  const { isModalOpenAddAddressBook } = useSelector((s) => s.addressBook)
  const [isOpenSelection, setIsOpenSelection] = useState(false)
  const [localSearch, setLocalSearch] = useState('')
  const [addressBookData, setAddressBookData] = useState([])
  const [recentData, setRecentData] = useState([])
  const [isFetchingLocal, setIsFetchingLocal] = useState(false)
  const [lastActiveField, setLastActiveField] = useState(null)
  const [hasSelected, setHasSelected] = useState(false)
  const contactsRequestId = useRef(0)

  const [fetchAddressBook] = useLazyFindAddressBookQuery()
  const [fetchCombinedContacts] = useLazyFetchProjectShareContactsQuery()
  const fetchContacts = (params) =>
    useCombinedContacts
      ? fetchCombinedContacts({ s: params.s }, true)
      : fetchAddressBook(params)
  const isExcludedContact = (contact) => {
    const userId =
      contact?.relationUserId ??
      contact?.relationEmailUserId ??
      contact?.userId ??
      contact?.id ??
      contact?.relationEmail ??
      contact?.relationPhoneNumber
    return excludeUserIds.some(
      (excludedId) => String(excludedId) === String(userId),
    )
  }
  const hasSelectableAddressBookContact = addressBookData.some(
    (contact) =>
      (contact?.relationPhoneNumber || contact?.relationEmail) &&
      !isExcludedContact(contact),
  )

  const debouncedSearch = useDebounce((value) => {
    const trimmedValue = value.trim()
    if (trimmedValue) {
      const requestId = ++contactsRequestId.current
      setIsFetchingLocal(true)
      fetchContacts({
        s: trimmedValue,
        ...(isPhoneUnRegistered && { isPhoneUnRegistered: true }),
        ...(isPhoneRegistered && { isPhoneRegistered: true }),
        ...(isEmailUnRegistered && { isEmailUnRegistered: true }),
        ...(isEmailRegistered && { isEmailRegistered: true }),
        ...(isPhoneVerified && { isPhoneVerified: true }),
        ...(isEmailVerified && { isEmailVerified: true }),
        ...(isHarvester && { isHarvester: true }),
        ...(isLandOwner && { isLandOwner: true }),
        ...(isNetwork && { isNetwork: true }),
      }).then((response) => {
        if (requestId !== contactsRequestId.current) return
        setAddressBookData(response?.data?.items || [])
        setIsFetchingLocal(false)
        setIsOpenSelection(true)
      }).catch(() => {
        if (requestId !== contactsRequestId.current) return
        setAddressBookData([])
        setIsFetchingLocal(false)
        setIsOpenSelection(true)
      })
    } else {
      setIsOpenSelection(false)
      setAddressBookData([])
    }
  }, 600)

  const handleManualChange = (e) => {
    const value = e.target.value
    setLocalSearch(value)
    setHasSelected(false)

    if (onSelectContact) {
      onSelectContact({}, fieldName)
    }

    if (value.length > 2) {
      debouncedSearch(value)
    } else {
      setIsOpenSelection(false)
      setAddressBookData([])
      handleInitialFetch()
    }
  }

  const handleSelectContact = (contact) => {
    const relationName = isUppercaseValue
      ? contact?.relationName?.toUpperCase()
      : contact?.relationName

    const displayText = contact?.relationPhoneNumber
      ? `${relationName} (${contact?.relationPhoneNumber})`
      : contact?.relationEmail
        ? `${relationName} (${contact?.relationEmail})`
        : relationName

    setLocalSearch(displayText)
    setIsOpenSelection(false)
    setHasSelected(true)
    if (onSelectContact) {
      onSelectContact(contact, fieldName)
    }
    if (clearOnSelect) {
      setLocalSearch('')
      setHasSelected(false)
    }
  }

  const handleInitialFetch = () => {
    setLastActiveField(fieldName)
    const requestId = ++contactsRequestId.current
    // if (!editValue) { // FOR AT THE MOMENT COMMENT THIS HANDLE
    setIsFetchingLocal(true)
    fetchContacts({
      s: '',
      size: 10,
      page: 0,
      sortby: 'createdAt',
      sortdir: 'desc',
      ...(isPhoneUnRegistered && { isPhoneUnRegistered }),
      ...(isPhoneRegistered && { isPhoneRegistered }),
      ...(isEmailUnRegistered && { isEmailUnRegistered }),
      ...(isEmailRegistered && { isEmailRegistered }),
      ...(isPhoneVerified && { isPhoneVerified }),
      ...(isEmailVerified && { isEmailVerified }),
      ...(isHarvester && { isHarvester }),
      ...(isLandOwner && { isLandOwner }),
      ...(isNetwork && { isNetwork: true }),
    }).then((response) => {
      if (requestId !== contactsRequestId.current) return
      if (isRecentTrx) {
        const recent = JSON.parse(
          localStorage.getItem(`savedContacts-${profile?.userId}`) || '[]',
        )
        const modifyrecent = recent.map((e) => {
          return {
            profile_img: e?.profileImg,
            relationEmail: e?.email,
            relationName: e?.fullName,
            relationPhoneNumber: e?.phoneNumber,
            relationUserId: e?.userId,
            ...e,
          }
        })
        setRecentData([...(modifyrecent || [])])
        setAddressBookData([...(response?.data?.items || [])])
      } else {
        setAddressBookData(response?.data?.items || [])
      }
      setIsFetchingLocal(false)
      setIsOpenSelection(true)
    }).catch(() => {
      if (requestId !== contactsRequestId.current) return
      setAddressBookData([])
      setIsFetchingLocal(false)
      setIsOpenSelection(true)
    })
    // }
  }

  useEffect(() => {
    return () => {
      setLocalSearch('')
      setAddressBookData([])
      setLastActiveField(null)
    }
  }, [])

  useEffect(() => {
    if (editValue) {
      setLocalSearch(editValue)
    } else {
      setLocalSearch('')
    }
  }, [editValue])

  useEffect(() => {
    if (valueName) {
      setLocalSearch(valueName)
    } else {
      setLocalSearch('')
    }
  }, [valueName])

  useEffect(() => {
    if (onFetchingChange) {
      onFetchingChange(isFetchingLocal)
    }
  }, [isFetchingLocal, onFetchingChange])

  useEffect(() => {
    if (!isModalOpenAddAddressBook && lastActiveField === fieldName) {
      handleInitialFetch()
    }
  }, [isModalOpenAddAddressBook, fieldName, lastActiveField])

  const toggleOpenCloseAddContact = () => {
    dispatch(setIsModalOpenAddAddressBook(true))
  }
  return (
    <div style={{ position: 'relative' }} className="w-100">
      <P size={isVessel ? 'regular' : 'default'} className="mb-2">
        {title}
        {isRequired && <span className="text-danger">*</span>}
      </P>

      <Input
        className={className}
        type="text"
        value={localSearch}
        disabled={disabled}
        onChange={handleManualChange}
        placeholder={placeholderDesc}
        onFocus={handleInitialFetch}
        // onBlur={() => setTimeout(() => setIsOpenSelection(false), 200)}
        onBlur={() => {
          if (!hasSelected && !isCanClose) {
            return
          }

          setTimeout(() => setIsOpenSelection(false), 200)
        }}
        invalid={invalid}
        innerRef={innerRef}
      />
      {isOpenSelection && !isCloseSelection && (
        <div
          style={{
            position: 'absolute',
            background: 'white',
            width: '100%',
            boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
            borderRadius: '8px',
            zIndex: 10,
            marginTop: '4px',
          }}
        >
          <div
            style={{
              maxHeight: '250px',
              overflowY: 'auto',
            }}
          >
            {isFetchingLocal ? (
              <div className="p-3 d-flex justify-content-center align-items-center">
                <Spinner size="sm" color="primary" />
              </div>
            ) : (
              <>
                {localSearch.length > 0 || recentData?.length < 1 ? (
                  <>
                    {hasSelectableAddressBookContact ? (
                      addressBookData
                        ?.filter(
                          (e) =>
                            (e?.relationPhoneNumber || e?.relationEmail) &&
                            !isExcludedContact(e),
                        )
                        ?.map((contact, index) => (
                          <div
                            key={index}
                            className="contact-item p-2 d-flex flex-column"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleSelectContact(contact)}
                          >
                            <P color="#101828">{contact?.relationName}</P>
                            <P color="#667085">
                              {contact?.relationPhoneNumber
                                ? contact?.relationPhoneNumber
                                : contact?.relationEmail
                                  ? contact?.relationEmail
                                  : ''}
                            </P>
                          </div>
                        ))
                    ) : (
                      <div className="p-2 text-muted">
                        Pencarian tidak ditemukan
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div className="px-2 text-muted text-sm mt-2">
                      TERAKHIR/SERING DIPILIH
                    </div>
                    {recentData
                      ?.filter(
                        (e) =>
                          (e?.relationPhoneNumber || e?.relationEmail) &&
                          !isExcludedContact(e),
                      )
                      ?.map((contact, index) => (
                        <div
                          key={index}
                          className="contact-item p-2 d-flex flex-column"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleSelectContact(contact)}
                        >
                          <P color="#101828">{contact?.relationName}</P>
                          <P color="#667085">
                            {contact?.relationPhoneNumber
                              ? contact?.relationPhoneNumber
                              : contact?.relationEmail
                                ? contact?.relationEmail
                                : ''}
                          </P>
                        </div>
                      ))}

                    <div className="px-2 text-muted mt-3 text-sm">
                      SEMUA KONTAK
                    </div>
                    {addressBookData
                      ?.filter(
                        (e) =>
                          (e?.relationPhoneNumber || e?.relationEmail) &&
                          !isExcludedContact(e),
                      )
                      ?.map((contact, index) => (
                        <div
                          key={index}
                          className="contact-item p-2 d-flex flex-column"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleSelectContact(contact)}
                        >
                          <P color="#101828">{contact?.relationName}</P>
                          <P color="#667085">
                            {contact?.relationPhoneNumber
                              ? contact?.relationPhoneNumber
                              : contact?.relationEmail
                                ? contact?.relationEmail
                                : ''}
                          </P>
                        </div>
                      ))}
                  </>
                )}
              </>
            )}
          </div>
          {!isFetchingLocal && !noAdd && (
            <div
              style={{
                padding: '8px',
                cursor: 'pointer',
                color: '#006386',
                background: 'white',
              }}
              onClick={() => {
                toggleOpenCloseAddContact()
                onClickAdd(localSearch)
              }}
            >
              + Tambah "{localSearch}" ke daftar kontak
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default InputAddressBook
